import React from "react";
import GallerySlider from "./GallerySlider";

export const Gallery = () => (
  <div id="portfolio" className="text-center">
    <div className="container">
      <div className="section-title">
        <h2>Galería</h2>
        <p>Algunas imágenes de nuestras instalaciones, actividades y eventos.</p>
      </div>
      <GallerySlider />
    </div>
  </div>
);
